/**
 * @param {object} theme
 */
const styles = theme => ({
    startNewButton: {
        backgroundColor: theme.palette.primary.backgroundColor,
        color: '#1A1A1A', //theme.messagesApp.startConversation.textColor,
        boxShadow: theme.palette.primary.flatBottomShadow,
        cursor: 'pointer',
        fontSize: '20px',
        fontWeight: 400,
        lineHeight: 1.05,
        letterSpacing: '-0.3px',
        padding: '5px 0px 5px 15px;',
        display: 'flex',
        alignItems: 'center',
        minHeight: 60,
        transition: 'all .3s ease-in-out',
        background: 'white',
        zIndex: 3,
        borderWidth: 0,
        width: '100%',
        font: 'Inter'
    },
    iconContainer: {
        // marginRight: '10px',
        width: '43px'
    },
    startNewIcon: {
        width: '32px',
        height: '32px',
        objectFit: 'contain'
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        width: '100%',
        padding: '0 10px'
    }
})

export default styles
